module.exports = __webpack_public_path__ + "img/8.cfae4ccb.png";